{
  ". Le contenu de la page de destination sera remplacé.": ". The destination page's content will be replaced.",
  "« {{part}} » : plage inversée": "‘{{part}}’: reversed range",
  "« {{part}} » n'est pas valide": "‘{{part}}’ is not valid",
  "« {{title}} » sera supprimée définitivement.": "‘{{title}}’ will be permanently deleted.",
  "(4 pages supplémentaires = +{{price}}€ par Yearbook)": "(4 extra pages = +€{{price}} per yearbook)",
  "(facultatif)": "(optional)",
  "(La modification de l'album remplacera la mise en page actuelle)": "(Changing the album will replace the current layout)",
  "(pas floues ou pixellisées)": "(not blurry or pixelated)",
  "(vide)": "(empty)",
  "{{count}} élève_one": "{{count}} student",
  "{{count}} élève_other": "{{count}} students",
  "{{count}} étoile_one": "{{count}} star",
  "{{count}} étoile_other": "{{count}} stars",
  "{{count}} mot non placé : {{words}}_one": "{{count}} word could not be placed: {{words}}",
  "{{count}} mot non placé : {{words}}_other": "{{count}} words could not be placed: {{words}}",
  "{{count}} mot_one": "{{count}} word",
  "{{count}} mot_other": "{{count}} words",
  "{{count}} page nécessaire_one": "{{count}} page required",
  "{{count}} page nécessaire_other": "{{count}} pages required",
  "{{count}} page utilisée_one": "{{count}} page used",
  "{{count}} page utilisée_other": "{{count}} pages used",
  "{{count}} page visible_one": "{{count}} visible page",
  "{{count}} page visible_other": "{{count}} visible pages",
  "{{count}} pages": "{{count}} pages",
  "{{count}} personne par page_one": "{{count}} person per page",
  "{{count}} personne par page_other": "{{count}} people per page",
  "{{count}} photo sélectionnée_one": "{{count}} photo selected",
  "{{count}} photo sélectionnée_other": "{{count}} photos selected",
  "{{count}} photo_one": "{{count}} photo",
  "{{count}} photo_other": "{{count}} photos",
  "{{count}} repère déjà placé_one": "{{count}} guide already placed",
  "{{count}} repère déjà placé_other": "{{count}} guides already placed",
  "{{count}} résultat_one": "{{count}} result",
  "{{count}} résultat_other": "{{count}} results",
  "{{count}} Yearbook_one": "{{count}} yearbook",
  "{{count}} Yearbook_other": "{{count}} yearbooks",
  "{{done}} / {{total}} remarques traitées": "{{done}} / {{total}} comments completed",
  "{{first}} ou {{last}} pages": "{{first}} or {{last}} pages",
  "{{first}} ou {{last}} pages utilisées": "{{first}} or {{last}} pages used",
  "{{sent}} / {{total}} photos envoyées": "{{sent}} / {{total}} photos sent",
  "*La couverture doit mesurer 430×307 mm. En JPG ou PNG avec une résolution de 300 dpi. Il s'agit d'un format A3 paysage avec 5 mm de fond perdu nécessaires pour l'impression.": "*The cover must measure 430×307 mm, in JPG or PNG at 300 dpi. This is landscape A3 with the 5 mm bleed required for printing.",
  "*Les images/PDF doivent faire 220x307mm (soit un A4 + 10mm de marge) en résolution 300dpi. Les marges seront coupées à l'impression": "*Images/PDFs must measure 220×307 mm (A4 + 10 mm margin) at 300 dpi. Margins will be trimmed when printed",
  "← Revenir à la sélection": "← Back to selection",
  "+ de couleurs": "More colours",
  "❤️ Favoris": "❤️ Favourites",
  "⭐ Recommandé": "⭐ Recommended",
  "💡 Cliquez sur l'emplacement précis de la page où vous souhaitez ajouter votre remarque": "💡 Click the exact location on the page where you want to add your comment",
  "📁 Mes couvertures": "📁 My covers",
  "📁 Mes fonds": "📁 My backgrounds",
  "📁 Mes modèles": "📁 My templates",
  "📖 Liseuse interactive – Utilisez les flèches ← → ou cliquez pour tourner les pages": "📖 Interactive reader – Use the ← → arrows or click to turn pages",
  "1er de couv": "Front cover",
  "1ère de couv.": "Front cover",
  "1ère de couverture": "Front cover",
  "2ème de couv": "Inside front cover",
  "2ème de couverture": "Inside front cover",
  "3ème de couverture": "Inside back cover",
  "4ème de couv.": "Back cover",
  "4ème de couverture": "Back cover",
  "À faire ({{count}})": "To do ({{count}})",
  "À l'attention de": "For the attention of",
  "À l'école": "At school",
  "À partir de": "From",
  "À placer": "To place",
  "À propos de vous": "About you",
  "Accès enregistrés": "Access settings saved",
  "Accès utilisateur": "User access",
  "Adresse de livraison": "Delivery address",
  "Adresse email invalide": "Invalid email address",
  "Affichage": "Display",
  "Afficher": "Show",
  "Afficher le panneau": "Show panel",
  "Afficher les commentaires ({{count}})": "Show comments ({{count}})",
  "Afficher ou masquer le chemin de fer": "Show or hide the page plan",
  "Afficher uniquement les pages :": "Show only these pages:",
  "Afin de toujours mieux vous accompagner, partagez-nous votre expérience": "To help us support you better, share your experience with",
  "Agrandir le zoom": "Zoom in",
  "Ajout d'un ou plusieurs fonds de page": "Add one or more page backgrounds",
  "Ajout du trombi dans le yearbook": "Add class portraits to the yearbook",
  "Ajouter": "Add",
  "Ajouter au panier": "Add to cart",
  "Ajouter aux favoris": "Add to favourites",
  "Ajouter des pages": "Add pages",
  "Ajouter des pages pour aérer mon Yearbook !": "Add pages to give my yearbook more space!",
  "Ajouter et continuer": "Add and continue",
  "Ajouter et continuer (Shift+Entrée)": "Add and continue (Shift+Enter)",
  "Ajouter et fermer": "Add and close",
  "Ajouter et fermer (Entrée)": "Add and close (Enter)",
  "Ajouter ma propre couverture": "Add my own cover",
  "Ajouter un commentaire": "Add a comment",
  "Ajouter un fichier": "Add a file",
  "Ajouter un mot": "Add a word",
  "Ajouter un QR Code": "Add a QR code",
  "Ajouter un repère": "Add a guide",
  "Ajouter un texte": "Add text",
  "Ajouter une adresse email…": "Add an email address…",
  "Ajouter une classe": "Add a class",
  "Ajouter une couleur": "Add a colour",
  "Ajouter une étape": "Add a step",
  "Ajouter une précision…": "Add a clarification…",
  "Ajouter une section": "Add a section",
  "Ajouter vos photos": "Add your photos",
  "Album": "Album",
  "Album Magique": "Magic album",
  "Annuler": "Cancel",
  "Annuler (Ctrl+Z)": "Undo (Ctrl+Z)",
  "Aperçu": "Preview",
  "Appliquer": "Apply",
  "Appliquer à toutes les pages": "Apply to all pages",
  "Après la page": "After page",
  "Aucun album ne correspond à « {{query}} »": "No album matches ‘{{query}}’",
  "Aucun destinataire disponible.": "No recipients available.",
  "Aucun échange pour le moment.": "No reviews yet.",
  "Aucun favori pour le moment.": "No favourites yet.",
  "Aucun fond disponible.": "No backgrounds available.",
  "Aucun fond personnalisé.": "No custom backgrounds.",
  "Aucun fond recommandé pour le moment.": "No recommended backgrounds yet.",
  "Aucun historique disponible pour cette page.": "No history available for this page.",
  "Aucun modèle de couverture disponible.": "No cover templates available.",
  "Aucun modèle disponible pour cette sélection.": "No templates available for this selection.",
  "Aucun modèle disponible.": "No templates available.",
  "Aucun modèle personnel. Créez-en un depuis le menu « ... » d'une page.": "No custom templates. Create one from a page's ‘...’ menu.",
  "Aucun mot n’a pu être placé.": "No words could be placed.",
  "Aucun QR Code disponible.": "No QR codes available.",
  "Aucun résultat pour « {{query}} ».": "No results for ‘{{query}}’.",
  "Aucun sticker disponible.": "No stickers available.",
  "Aucun utilisateur": "No users",
  "Aucune": "None",
  "Aucune classe trouvée.": "No classes found.",
  "Aucune couleur favorite. Ajoutez-en depuis le panneau Texte.": "No favourite colours. Add some in the Text panel.",
  "Aucune couverture personnalisée.": "No custom covers.",
  "Aucune grille pour le moment.": "No crosswords yet.",
  "Aucune page à afficher.": "No pages to display.",
  "Aucune page générée. Veuillez réessayer.": "No pages generated. Please try again.",
  "Aucune remarque validée.": "No approved comments.",
  "Aucune remarque.": "No comments.",
  "Avant d'ajouter votre Yearbook au panier, vérifiez bien les points suivants :": "Before adding your yearbook to the cart, check the following:",
  "Avant de confirmer l'envoi de votre Yearbook en vérification auprès des graphistes, vérifiez bien les points suivants :": "Before sending your yearbook to the designers for review, check the following:",
  "Avis Google": "Google review",
  "Bas": "Bottom",
  "Bloquer des pages": "Lock pages",
  "Bouche à oreille": "Word of mouth",
  "Carré": "Square",
  "Cela permettra à nos graphistes de prendre connaissance de vos remarques": "This lets our designers review your comments",
  "Cercle": "Circle",
  "Cette action est définitive et ne peut pas être annulée.": "This action is permanent and cannot be undone.",
  "Cette action est définitive.": "This action is permanent.",
  "Cette action est définitive. Le fond sera retiré de vos fonds personnalisés.": "This action is permanent. The background will be removed from your custom backgrounds.",
  "Cette action est irréversible. La photo sera définitivement supprimée.": "This action cannot be undone. The photo will be permanently deleted.",
  "Cette adresse est déjà ajoutée": "This address has already been added",
  "Chargement de l'album…": "Loading album…",
  "Chargement de l'historique…": "Loading history…",
  "Chargement…": "Loading…",
  "Chemin de fer": "Page plan",
  "Chez un particulier": "To a private address",
  "Choisir": "Choose",
  "Choisir un album…": "Choose an album…",
  "Choisir un dossier": "Choose a folder",
  "Choisir un fichier": "Choose a file",
  "Choisir un thème…": "Choose a theme…",
  "Choisir une couleur": "Choose a colour",
  "Choisir une ou plusieurs images": "Choose one or more images",
  "Choisir une photo": "Choose a photo",
  "Choisissez la page à intervertir avec": "Choose the page to swap with",
  "Choisissez la page de destination où dupliquer": "Choose the destination page for",
  "Choisissez le format et le nombre de pages souhaités.": "Choose the format and number of pages.",
  "Choisissez un style de remplissage": "Choose a photo layout style",
  "Choisissez une méthode": "Choose a method",
  "Choisissez une version pour restaurer le contenu de la page.": "Choose a version to restore the page content.",
  "Choix de la page": "Choose a page",
  "Choix du modèle": "Choose a template",
  "Choix du nombre de personnes par page": "Choose the number of people per page",
  "Choix par nombre de personnes": "Choose by number of people",
  "Classiques": "Classic",
  "Client": "Client",
  "Cliquez ensuite sur la photo concernée dans la page": "Then click the affected photo on the page",
  "Cliquez sur la page pour placer votre commentaire": "Click the page to place your comment",
  "Cliquez sur la photo pixelisée dans la page": "Click the pixelated photo on the page",
  "Cliquez sur le bandeau au-dessus d’une page pour lui donner une section.": "Click the band above a page to give it a section.",
  "Code postal": "Postcode",
  "Comment avez-vous connu 1Year1Book ?": "How did you hear about 1Year1Book?",
  "Commentaire": "Comment",
  "Commentaire de {{author}}": "Comment by {{author}}",
  "Configurez votre album et laissez la magie opérer !": "Set up your album and let the magic happen!",
  "Confirmation de commande": "Order confirmation",
  "Correct": "Fair",
  "Couleur de fond": "Background colour",
  "Couleur de la forme": "Shape colour",
  "Couleur du nom": "Name colour",
  "Couleur du sticker": "Sticker colour",
  "Couleur du texte": "Text colour",
  "Couleurs": "Colours",
  "Couleurs personnalisables": "Customisable colours",
  "Couv.": "Cover",
  "Couverture": "Cover",
  "Couverture envoyée": "Cover sent",
  "Couvertures": "Covers",
  "Créatifs": "Creative",
  "Création…": "Creating…",
  "Créer": "Create",
  "Créer le modèle": "Create template",
  "Créer mon album": "Create my album",
  "Créer un modèle": "Create a template",
  "Créer un nouveau dossier": "Create a new folder",
  "Créez une nouvelle classe pour le trombinoscope.": "Create a new class for the class portraits.",
  "Créez une page unique en un clic grâce à nos modèles et vos photos.": "Create a unique page in one click with our templates and your photos.",
  "Créez une règle d'aide à la mise en page. Les éléments s'aimanteront dessus.": "Create a layout guide. Elements will snap to it.",
  "Dans le livre": "In the book",
  "dans le Yearbook": "in the yearbook",
  "de téléphone de la personne qui réceptionnera le(s) colis.": "of the person who will receive the parcel(s).",
  "Définition / indice": "Definition / clue",
  "Déposez vos photos ici": "Drop your photos here",
  "Description": "Description",
  "Description disponible": "Description available",
  "Détail de la remarque…": "Comment details…",
  "disponible sur la plateforme.": "available on the platform.",
  "Distance (mm) — max {{max}}": "Distance (mm) — max {{max}}",
  "Donnez un nom à cette page pour mieux l'identifier": "Give this page a name to identify it more easily",
  "Donnez votre note": "Give your rating",
  "Dossier de destination": "Destination folder",
  "Droite": "Right",
  "Dupliquer": "Duplicate",
  "Dupliquer la page": "Duplicate page",
  "Dupliquer la page vers…": "Duplicate page to…",
  "Échange": "Round",
  "Écrivez votre remarque ici...": "Write your comment here…",
  "Éditer": "Edit",
  "Effacer la recherche": "Clear search",
  "Élève / Étudiant": "Pupil / Student",
  "en quelques clics.": "in just a few clicks.",
  "Enlever le fond de page": "Remove page background",
  "Enlever le trombi du livre": "Remove class portraits from the book",
  "Enregistrer": "Save",
  "Envoi en cours...": "Sending...",
  "Envoi en cours…": "Sending…",
  "Envoi en vérification": "Send for review",
  "Envoi…": "Sending…",
  "Envoyé au client": "Sent to the client",
  "Envoyé au graphiste": "Sent to the designer",
  "Envoyer": "Send",
  "Envoyer en impression": "Send to print",
  "Envoyer en vérification": "Send for review",
  "Envoyer le livre au graphiste": "Send the book to the designer",
  "Envoyer les corrections au client": "Send corrections to client",
  "Envoyer mes remarques aux graphistes": "Send my comments to the designers",
  "Envoyer mon avis et lancer l'impression": "Send my feedback and start printing",
  "Erreur": "Error",
  "Erreur {{status}}": "Error {{status}}",
  "Erreur lors de l'enregistrement": "Error saving",
  "Erreur lors de l'envoi": "Error sending",
  "Erreur lors du renommage": "Error renaming album",
  "Erreur réseau": "Network error",
  "Erreur:": "Error:",
  "Est-ce votre premier yearbook avec 1Year1Book ?": "Is this your first yearbook with 1Year1Book?",
  "Établissement": "School",
  "Étape {{step}}/{{total}} — {{title}}": "Step {{step}}/{{total}} — {{title}}",
  "Ex : CM2 - Mme Dupont": "E.g. Year 6 – Ms Dupont",
  "Ex : Mots croisés de la promo": "E.g. Class crossword",
  "Expérience 1Year1Book globale": "Overall 1Year1Book experience",
  "Explorez nos yearbooks pour trouver l'inspiration.": "Explore our yearbooks for inspiration.",
  "Favori": "Favourite",
  "Félicitations ! Votre yearbook part en impression": "Congratulations! Your yearbook is going to print",
  "Félicitations, votre livre est envoyé en vérification chez 1Year1Book.": "Congratulations, your book has been sent to 1Year1Book for review.",
  "Fermer": "Close",
  "Fond du bloc": "Block background",
  "Fonds": "Backgrounds",
  "Fonds de page": "Page backgrounds",
  "Forcer le retour chez 1Y1B": "Force return to 1Y1B",
  "Format et taille": "Format and size",
  "Formes": "Shapes",
  "Gauche": "Left",
  "Génération en cours…": "Generating…",
  "Générer l'album": "Generate album",
  "Générer les modèles": "Generate templates",
  "Générer une page": "Generate a page",
  "Générez automatiquement votre album ! Les photos sont placées automatiquement et vous pouvez ensuite les modifier à votre guise.": "Generate your album automatically! Photos are placed automatically and you can then edit them as you wish.",
  "Glissez-déposez (png, jpg, jpeg)": "Drag and drop (png, jpg, jpeg)",
  "Glissez-déposez vos photos ici": "Drag and drop your photos here",
  "Grille vide": "Empty crossword",
  "Gros texte en haut de la page": "Large text at the top of the page",
  "Haut": "Top",
  "Historique de {{page}}": "History of {{page}}",
  "Historique de la page": "Page history",
  "Horizontal": "Horizontal",
  "Import en cours…": "Importing…",
  "Importer des photos": "Import photos",
  "Importer mes propres fonds ou mes pages perso": "Import my backgrounds or custom pages",
  "Impossible d'appliquer le repère à toutes les pages": "Unable to apply the guide to all pages",
  "Impossible d'enregistrer le commentaire.": "Unable to save the comment.",
  "Impossible de charger l'historique": "Unable to load history",
  "Impossible de charger les utilisateurs": "Unable to load users",
  "Impossible de créer la classe.": "Unable to create the class.",
  "Impossible de sauvegarder les mots croisés": "Unable to save the crossword",
  "Imprimer la page": "Print page",
  "inconnu": "unknown",
  "Insérer dans la page": "Insert on page",
  "Inspiration": "Inspiration",
  "Internet / Réseaux sociaux": "Internet / Social media",
  "Intervertir": "Swap",
  "Intervertir avec une autre page…": "Swap with another page…",
  "Intervertir les pages": "Swap pages",
  "J'ai bien vérifié mon fichier": "I have checked my file",
  "Je garde la photo": "Keep this photo",
  "Je remplace la photo": "Replace this photo",
  "Je valide": "I approve",
  "Je vérifie": "I'll check",
  "L'éditeur en ligne et ses outils.": "The online editor and its tools.",
  "L'impression de vos Yearbooks est lancée": "Your yearbooks are now being printed",
  "L'orthographe des textes a bien été vérifiée ?": "Has the spelling been checked?",
  "La création de l'album remplacera la mise en page actuelle": "Creating the album will replace the current layout",
  "La création du modèle a échoué. Réessayez.": "Template creation failed. Please try again.",
  "La modification n'a pas pu être enregistrée.": "The change could not be saved.",
  "La page {{page}} n'existe pas": "Page {{page}} does not exist",
  "Langue": "Language",
  "Le plus de photos possible": "As many photos as possible",
  "Le rendu final de votre livre.": "Your book's final appearance.",
  "Le repère sera ajouté à l'ensemble des pages non verrouillées du livre.": "The guide will be added to all unlocked pages in the book.",
  "Le yearbook a été validé !": "The yearbook has been approved!",
  "Les autres pages seront masquées pour elle.": "Other pages will be hidden from them.",
  "Les couleurs de ce fond sont personnalisables": "This background's colours can be customised",
  "Les pages seront bientôt disponibles, Raphaëlle vous envoie très prochainement votre facture mise à jour.": "The pages will be available soon. Raphaëlle will send your updated invoice shortly.",
  "Les pages supplémentaires s'ajoutent par 4.": "Extra pages are added in blocks of 4.",
  "Les photos deviendront des emplacements vides. Textes, stickers et formes sont conservés.": "Photos will become empty slots. Text, stickers and shapes are preserved.",
  "Les Yearbooks seront-ils livrés :": "Will the yearbooks be delivered:",
  "Lien": "Link",
  "Ligne": "Line",
  "Liseuse": "Reader",
  "Livraison offerte dés 50€": "Free delivery from €50",
  "Livre validé": "Book approved",
  "Marquer une photo pixelisée": "Flag a pixelated photo",
  "Masquer": "Hide",
  "Masquer le panneau": "Hide panel",
  "Masquer les commentaires ({{count}})": "Hide comments ({{count}})",
  "Merci": "Thank you",
  "Merci de noter les 4 critères ci-dessus": "Please rate the 4 criteria above",
  "Merci de répondre à toutes les questions obligatoires": "Please answer all required questions",
  "Merci pour votre avis !": "Thank you for your feedback!",
  "Merci pour votre commande.": "Thank you for your order.",
  "Mes couleurs enregistrées": "My saved colours",
  "Mes couleurs préférées": "My favourite colours",
  "Mes informations": "My details",
  "Mes photos sont en HD ou à minima de bonnes qualités ?": "Are my photos in HD or at least of good quality?",
  "Message…": "Message…",
  "Mettre le nom ou prénom à la ligne": "Put the first or last name on a new line",
  "Modèle {{current}} / {{total}}": "Template {{current}} / {{total}}",
  "Modèles": "Templates",
  "Modifier": "Edit",
  "Modifier la grille": "Edit crossword",
  "Modifier la réponse": "Edit reply",
  "Modifier le format": "Change format",
  "Modifier le format de mon album": "Change my album format",
  "Modifier le trombi": "Edit class portraits",
  "Modifier mon album": "Update my album",
  "Mot": "Word",
  "Mots & définitions (min. {{min}})": "Words & clues (min. {{min}})",
  "Mots croisés": "Crosswords",
  "Mots non placés": "Unplaced words",
  "🆕 Nouveautés": "🆕 New arrivals",
  "Nom": "Last name",
  "Nom de l'album": "Album name",
  "Nom de l'établissement": "School name",
  "Nom de la classe": "Class name",
  "Nom de la page": "Page name",
  "Nom du dossier": "Folder name",
  "Nom du modèle": "Template name",
  "Nom et prénom du destinataire": "Recipient's full name",
  "Nom mis à jour": "Name updated",
  "Nom Prénom": "Last name First name",
  "Nombre d'échanges avec les graphistes compris dans votre contrat": "Number of designer review rounds included in your contract",
  "Nombre de pages": "Number of pages",
  "Non": "No",
  "Non, on remet ça": "No, we're doing it again",
  "Note…": "Note…",
  "Notre accompagnement": "Our support",
  "Nouvelle étape": "New step",
  "Nouvelle grille": "New crossword",
  "Nouvelle grille de mots croisés": "New crossword",
  "Nouvelle remarque": "New comment",
  "Nouvelle section": "New section",
  "Numéro et rue": "Street and number",
  "Ordre": "Order",
  "Organisez vos pages par section et suivez l’avancement.": "Organise your pages into sections and track progress.",
  "Orientation": "Orientation",
  "ou cliquez pour importer depuis votre ordinateur": "or click to import from your computer",
  "ou cliquez pour parcourir votre ordinateur": "or click to browse your computer",
  "Oui": "Yes",
  "Oui, c'est une première !": "Yes, it's a first!",
  "Outils de l’éditeur": "Editor tools",
  "Page": "Page",
  "page {{first}} à {{last}}": "pages {{first}} to {{last}}",
  "page {{page}}": "page {{page}}",
  "Page magique": "Magic page",
  "page(s)": "page(s)",
  "Pages enregistrées": "Pages saved",
  "Pages visibles par personne, ex.": "Visible pages per person, e.g.",
  "Par mon école": "Through my school",
  "Paramètres": "Settings",
  "Parcourir l'ensemble des designs disponibles": "Browse all available designs",
  "Parent d'élève / Administration": "Parent / School staff",
  "Pas satisfait": "Not satisfied",
  "Paysage": "Landscape",
  "Personnaliser le trombi": "Customise class portraits",
  "personne par page_one": "person per page",
  "personne par page_other": "people per page",
  "Personnes autorisées :": "Authorised people:",
  "Peu satisfait": "Somewhat dissatisfied",
  "Photos": "Photos",
  "Photos à vérifier": "Photos to check",
  "Pièce jointe": "Attachment",
  "Placé sur la page {{page}}": "Placed on page {{page}}",
  "Placé sur les pages {{first}} à {{last}}": "Placed on pages {{first}} to {{last}}",
  "Placer « {{name}} »": "Place ‘{{name}}’",
  "Placer dans la page": "Place on page",
  "Police": "Font",
  "Portrait": "Portrait",
  "pour": "for",
  "Prénom": "First name",
  "Prénom Nom": "First name Last name",
  "Prénom NOM": "First name LAST NAME",
  "PRÉNOM NOM": "FIRST NAME LAST NAME",
  "Prêt à envoyer 🚀": "Ready to send 🚀",
  "Privilégier de grandes photos": "Prioritise large photos",
  "Prix par Yearbook": "Price per yearbook",
  "QR Code": "QR Code",
  "Qualité insuffisante": "Insufficient quality",
  "Qualité moyenne": "Average quality",
  "Qualité OK": "Good quality",
  "Rechercher un album...": "Search albums…",
  "Rechercher un sticker…": "Search stickers…",
  "Rechercher une personne…": "Search for a person…",
  "Rectangle": "Rectangle",
  "Réduire le zoom": "Zoom out",
  "Refaire": "Redo",
  "Refaire (Ctrl+Y)": "Redo (Ctrl+Y)",
  "Réinitialiser la page": "Reset page",
  "Réinitialiser le zoom": "Reset zoom",
  "Relecture du YearBook": "YearBook proofreading",
  "Remarques": "Comments",
  "Remarques pour les graphistes": "Comments for the designers",
  "Remplacer la photo": "Replace photo",
  "Renommer l'album": "Rename album",
  "Renommer la page": "Rename page",
  "Repasser en à faire": "Reopen",
  "Repère ajouté": "Guide added",
  "Repère ajouté à toutes les pages": "Guide added to all pages",
  "Répondre": "Reply",
  "Réponse": "Reply",
  "Retirer": "Remove",
  "Retirer de la section": "Remove from section",
  "Retirer des favoris": "Remove from favourites",
  "Retour": "Back",
  "Retour sur le site": "Back to the website",
  "Retour vers le site": "Back to the website",
  "Revenir à cette version": "Restore this version",
  "Sans titre": "Untitled",
  "Satisfaction visuelle du yearbook": "Yearbook visual satisfaction",
  "Satisfait": "Satisfied",
  "Sauvegarde automatique": "Autosave",
  "Sauvegarde en cours…": "Saving…",
  "Sauvegarde impossible": "Unable to save",
  "Section": "Section",
  "Sélectionner le nombre de personnes par page puis le design": "Choose the number of people per page, then the design",
  "Sélectionnez la photo de remplacement.": "Select the replacement photo.",
  "Sélectionnez le nombre de pages à ajouter": "Select the number of pages to add",
  "Seuls les administrateurs peuvent valider ce livre.": "Only administrators can approve this book.",
  "Soit un total de": "A total of",
  "Sous-titre": "Subtitle",
  "Spread précédent": "Previous spread",
  "Spread suivant": "Next spread",
  "Stickers": "Stickers",
  "Stickers & Formes": "Stickers & Shapes",
  "Style": "Style",
  "Style et disposition": "Style and layout",
  "Suivant": "Next",
  "Suivi client et graphiste.": "Support from our team and designers.",
  "Suivi des échanges": "Review history",
  "Suppression impossible": "Unable to delete",
  "Supprimer": "Delete",
  "Supprimer ce fond": "Delete this background",
  "Supprimer ce fond ?": "Delete this background?",
  "Supprimer cette couleur": "Delete this colour",
  "Supprimer cette photo ?": "Delete this photo?",
  "Supprimer cette remarque ?": "Delete this comment?",
  "Supprimer cette section ? Les pages ne sont pas supprimées.": "Delete this section? Pages are not deleted.",
  "Supprimer la grille ?": "Delete this crossword?",
  "Sur quelle page appliquer ce modèle ?": "On which page should this template be applied?",
  "Sur quelle page placer le trombinoscope ?": "On which page should the class portraits be placed?",
  "Taille": "Size",
  "Téléphone": "Phone",
  "Texte": "Text",
  "Texte au milieu de la page": "Text in the middle of the page",
  "Texte italique sous le titre": "Italic text below the title",
  "Thème": "Theme",
  "Titre": "Title",
  "Titre de la remarque": "Comment title",
  "Titre ou thème": "Title or theme",
  "Tous les élèves sont présent·e·s dans le Trombinoscope ?": "Are all students included in the class portraits?",
  "Tout": "All",
  "Tout cocher": "Select all",
  "Tout décocher": "Deselect all",
  "Tout retirer": "Remove all",
  "Toutes les pages": "All pages",
  "Tranche": "Spine",
  "Très satisfait": "Very satisfied",
  "Trombi": "Class photos",
  "Trombi complet": "Full class portraits",
  "Trombi simple": "Simple class portraits",
  "Trombinoscope": "Class portraits",
  "Trombinoscope COMPLET (nom + prénom + citation + photo)": "FULL class portraits (last name + first name + quote + photo)",
  "Trombinoscope SIMPLE (nom + prénom + photo)": "SIMPLE class portraits (last name + first name + photo)",
  "Type de trombinoscope": "Class portrait type",
  "Un mix de grandes et de petites photos": "A mix of large and small photos",
  "Un nouveau tour de relecture sera demandé.": "A new review round will be requested.",
  "Une erreur est survenue lors de l'envoi.": "An error occurred while sending.",
  "Une erreur est survenue.": "An error occurred.",
  "Une erreur réseau est survenue.": "A network error occurred.",
  "Une suggestion, une amélioration, une fonctionnalité dont vous rêvez…": "A suggestion, an improvement, a feature you'd love…",
  "Une version vous sera envoyée pour validation finale.": "A version will be sent to you for final approval.",
  "Uploader un couv.": "Upload cover",
  "Uploader une couverture": "Upload a cover",
  "Validation du livre avant impression": "Book approval before printing",
  "Validé par l'admin": "Approved by the administrator",
  "Validées ({{count}})": "Approved ({{count}})",
  "Valider": "Approve",
  "Valider la commande": "Confirm order",
  "Valider le livre": "Approve the book",
  "Vérification des droits…": "Checking permissions…",
  "Version {{number}}": "Version {{number}}",
  "Vertical": "Vertical",
  "Veuillez nous communiquer, s'il vous plaît, l'adresse précise de livraison à laquelle": "Please provide the exact delivery address to which",
  "Ville": "City",
  "Visible par tous les administrateurs de l'album.": "Visible to all album administrators.",
  "Voir le suivi des échanges": "View review history",
  "Voir les variantes de couleurs": "View colour variants",
  "Voir plus ({{count}} restantes)": "Show more ({{count}} remaining)",
  "Voir tous les modèles": "View all templates",
  "Vos idées": "Your ideas",
  "Vos idées nous permettent de toujours mieux vous satisfaire — n'hésitez pas !": "Your ideas help us serve you better — don't hesitate!",
  "Vos retours nous aident à toujours mieux vous accompagner.": "Your feedback helps us support you better.",
  "Votre album en 3 clics": "Your album in 3 clicks",
  "Votre commentaire (facultatif)": "Your comment (optional)",
  "Votre commentaire…": "Your comment…",
  "Votre livre va être envoyé chez les graphistes 1Year1Book pour vérification.": "Your book will be sent to the 1Year1Book designers for review.",
  "Votre message…": "Your message…",
  "Votre plateforme dédiée": "Your dedicated platform",
  "Votre remarque sera envoyée aux graphistes lors de la vérification de votre Yearbook": "Your comment will be sent to the designers when your yearbook is reviewed",
  "Votre réponse…": "Your reply…",
  "Votre ressenti général sur l'aventure.": "Your overall experience.",
  "Votre satisfaction": "Your satisfaction",
  "Voulez-vous vraiment réinitialiser cette page ? Tous les éléments seront supprimés.": "Do you really want to reset this page? All elements will be deleted.",
  "Vous êtes :": "You are:",
  "Vous pouvez aussi nous aider en mettant un avis sur Google et/ou Trustpilot !": "You can also help us by leaving a review on Google and/or Trustpilot!",
  "Vous serez tenu informé par email lorsque la version à valider sera": "You will be notified by email when the version to approve is",
  "vous souhaitez que les yearbooks soient livrés, ainsi que les noms, prénoms et numéros": "you want the yearbooks delivered, as well as the full name and phone number",
  "Vue d'ensemble": "Overview",
  "Zoom arrière": "Zoom out",
  "Zoom avant": "Zoom in"
}